export default __webpack_public_path__ + "locales/ar-SA/Webhooks.json?hash=d88cec29e8f9917799fa75f42e58c2c1";